import { makeTintingRequest } from "../makeTintingRequest";

import { GetPastasResponse } from "./getPastasList.typed";

export const getPastasList = async () => {
  return await makeTintingRequest<GetPastasResponse[]>({
    url: `/v1/pasta`,
    method: "GET",
  });
};
